import React from "react";
import { createRoot } from "react-dom/client";
import { LocationProvider } from "./context";
import LocationList from "./LocationList";
import LocationMap from "./LocationMapV2";
import LocationListRefresh from "./LocationListRefresh";
import LocationDebug from "./LocationDebug";

const LocationApp = ({ project }) => (
  <LocationProvider project={project}>
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="inner-wrapper">
            <LocationMap />
            <LocationList />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col text-start py-3 px-5 gp-locations-legend">
          <div className="legend-items">
            <div className="op-projects">Operational</div>
            <div className="dev-projects">In development</div>
          </div>
        </div>
        <div className="col text-end py-3 px-5">
          <LocationListRefresh />
        </div>
      </div>
      {/* <LocationDebug /> */}
    </div>
  </LocationProvider>
);

const container = document.getElementById("gp-location-root");
if (container) {
  const root = createRoot(container);
  const project = container.dataset.project ? container.dataset.project : null;
  root.render(<LocationApp project={project} />);
}
